import { sum } from 'mathjs'
import { filter } from 'lodash'

function calculateSubscale(item) {
    item.sum = filter(item.sum, (o) => o !== null)

    if (item.sum.length > 0) {
        return sum(item.sum) / item.sum.length
    }

    return null
}

function calculateProcentualValue(item) {
    if (item.maxValue == undefined) {
        item.maxValue = false
    }

    let totalQuestions = item.sum.length

    if (item.maxValue) {
        item.sum = filter(item.sum, (o) => o <= item.maxValue)
    }

    let denominator = totalQuestions * item.maxValue

    if (denominator > 0) {
        return (sum(item.sum) / denominator) * 100
    }

    return null
}

export default function calculator(sender, options, identifier, category) {
    let r = sender.data

    let ST = calculateProcentualValue({
        name: 'ST',
        sum: [r.ST.ST1, r.ST.ST2, r.ST.ST3, r.ST.ST4, r.ST.ST5],
        maxValue: 4,
    })

    let APA = calculateProcentualValue({
        name: 'APA',
        sum: [r.AP.A1, r.AP.A2],
        maxValue: 4,
    })

    let APP = calculateProcentualValue({
        name: 'APP',
        sum: [r.AP.P2, r.AP.P3, r.AP.P4],
        maxValue: 4,
    })

    let UEU = calculateProcentualValue({
        name: 'UEU',
        sum: [r.UE.U1, r.UE.U2, r.UE.U3],
        maxValue: 4,
    })

    let UEE = calculateProcentualValue({
        name: 'UEE',
        sum: [r.UE.E1, r.UE.E2, r.UE.E3],
        maxValue: 4,
    })

    let SE = calculateProcentualValue({
        name: 'SE',
        sum: [r.SE.SE1, r.SE.SE2, r.SE.SE3],
        maxValue: 4,
    })

    let BW = calculateProcentualValue({
        name: 'BW',
        sum: [r.TU.B1, r.TS.B2, r.HB.B3],
        maxValue: 3,
    })

    let ER = calculateProcentualValue({
        name: 'ER',
        sum: [r.TU.ER1, r.TS.ER2, r.TS.ER3, r.HB.ER4],
        maxValue: 3,
    })

    let PS = calculateProcentualValue({
        name: 'PS',
        sum: [r.TU.PS1, r.TU.PS2, r.TS.PS3, r.TS.PS4, r.TS.PS5, r.HB.PS6],
        maxValue: 3,
    })

    let SV = calculateProcentualValue({
        name: 'SV',
        sum: [r.TU.S1, r.TS.S2, r.HB.S3],
        maxValue: 3,
    })

    let GKS = calculateProcentualValue({
        name: 'GKS',
        sum: [
            r.GKS.GKS1,
            r.GKS.GKS2,
            r.GKS.GKS3,
            r.GKS.GKS4,
            r.GKS.GKS5,
            r.GKS.GKS6,
            r.GKS.GKS7,
            r.GKS.GKS8,
        ],
        maxValue: 3,
    })

    let GZS = calculateSubscale({ name: 'GZS', sum: [ST, APA, APP, UEU, UEE, SE] })
    let HF = calculateSubscale({ name: 'HF', sum: [BW, ER, PS, SV] })
    let HMS = calculateSubscale({ name: 'HMS', sum: [GZS, HF, GKS] })
    let VE = calculateSubscale({ name: 'VE', sum: [ST, HF] })

    return {
        identifier,
        category,
        rolle: r.rolle,
        rollenName: r.rollenName,
        existingConcept: r.existingConcept,
        betreuung: r.betreuung,
        participatingInOtherProjects: r.participatingInOtherProjects,
        projectName: r.projectName,
        ST, APA, APP, UEU, UEE, SE,
        BW, ER, PS, SV,
        GZS, HF, GKS, HMS, VE,
        rawData: r,
    }
}
